import { fetcher } from '@commenda/utils';
import { IBankAccount } from './types';

interface UpdateRemittanceAccountProps {
  isRemittanceAccount: boolean;
}

export async function updateRemittanceAccount(
  bankAccountId: string,
  data: UpdateRemittanceAccountProps,
  token?: string | undefined
): Promise<{
  success: boolean;
  data: IBankAccount;
}> {
  const res = await fetcher(
    `bankAccount/${bankAccountId}/remittance`,
    {
      method: 'PUT',
      body: data,
    },
    token
  );

  const responseData = await res.json();

  return {
    success: res.ok,
    data: responseData,
  };
}
